import React from "react";
import { useI18n } from "../../i18n/I18nContext";

const PARTNERS = [
  {
    name: "Deckhouse",
    url: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/eh35cms1_Deckhouse_logo.png",
    tone: "dark",
    testid: "partner-deckhouse",
  },
  {
    name: "Delta Solutions",
    url: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/fvct6cvp_Delta_Solutions_logo.png",
    tone: "dark",
    testid: "partner-delta",
  },
  {
    name: "ICL Системные технологии",
    url: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/c7x5vrsm_ICL_logo.png",
    tone: "dark",
    testid: "partner-icl",
  },
  {
    name: "IT FB Group",
    url: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/u4jegp4v_IT_FB_logo.png",
    tone: "dark",
    testid: "partner-itfb",
  },
  {
    name: "Machine Intelligence Laboratory",
    url: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/pzsb35o6_MIL_logo.png",
    tone: "dark",
    testid: "partner-mil",
  },
  {
    name: "РСК",
    url: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/tkyh3xq0_rsc_logo.png",
    tone: "dark",
    testid: "partner-rsc",
  },
  {
    name: "Скала",
    url: "https://customer-assets.emergentagent.com/job_inboost-ai-engine/artifacts/3m2dz9f1_skala_logo.png",
    tone: "light",
    testid: "partner-skala",
  },
];

export const Partners = () => {
  const { t } = useI18n();

  return (
    <section id="partners" data-testid="partners-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-12">
          <div className="lg:col-span-7">
            <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan mb-3">
              {t.partners.sectionNum}
            </div>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              {t.partners.headlinePart1}
              <br />
              <span className="text-muted">{t.partners.headlinePart2}</span>
            </h2>
          </div>
          <div className="lg:col-span-5 self-end">
            <p className="text-muted text-sm leading-relaxed">
              {t.partners.desc}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4">
          {PARTNERS.map((p) => {
            const isLight = p.tone === "light";
            return (
              <div
                key={p.testid}
                data-testid={p.testid}
                className={`group relative aspect-square rounded-2xl border overflow-hidden hover:border-brand/40 hover:-translate-y-1 transition-all duration-300 ${
                  isLight
                    ? "bg-white border-ink-text/10"
                    : "bg-[#0A0F1E] border-ink-text/8"
                }`}
                style={{
                  boxShadow:
                    "0 1px 2px rgba(10,15,30,0.04), 0 8px 24px rgba(10,15,30,0.06)",
                }}
              >
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                  style={{
                    background:
                      "radial-gradient(ellipse 80% 60% at 50% 100%, rgba(0,153,201,0.18), transparent 60%)",
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center p-5">
                  <img
                    src={p.url}
                    alt={p.name}
                    className="max-w-[85%] max-h-[80%] w-auto h-auto object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Partners;
